import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { WebServiceContext } from 'contexts/WebServiceContext';
import { useContext } from 'react';
import ReactJson from 'react-json-view';

export const WebServiceConfigJSON = () => {
  const ctx = useContext(WebServiceContext);

  return (
    <FlexLayout p="xl">
      <H4 mb="lg" fontWeight="semiBold" fontSize="xl">
        Web service configuration
      </H4>
      <Box width="full">
        <ReactJson src={ctx?.state?.schema || {}} name={null} theme="solarized" />
      </Box>
    </FlexLayout>
  );
};
